module.exports = __webpack_public_path__ + "img/ars-technica.bc644016.png";